var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.519 22.72C14.3326 22.9079 15.165 23.0019 16 23C23 23 28 16 28 16C26.8878 14.5427 25.5887 13.2382 24.136 12.12M21.492 10.4C19.7994 9.50151 17.9162 9.02146 16 9C9 9 4 16 4 16C5.69746 18.2194 7.82868 20.0702 10.264 21.44M16 20.6C17.2838 20.6107 18.5192 20.1109 19.4345 19.2108C20.3499 18.3106 20.8702 17.0838 20.881 15.8M19.458 12.4C18.5335 11.4973 17.2926 10.9919 16.0005 10.9919C14.7084 10.9919 13.4675 11.4973 12.543 12.4C12.0897 12.8426 11.7295 13.3715 11.4835 13.9553C11.2376 14.5392 11.1109 15.1664 11.1109 15.8C11.1109 16.4336 11.2376 17.0608 11.4835 17.6447C11.7295 18.2285 12.0897 18.7574 12.543 19.2",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8.5L7.5 24",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidden);
export default __webpack_public_path__ + "static/media/hidden.b5a918210ed163a971774a045c058b22.svg";
export { ForwardRef as ReactComponent };